<ion-card class="tarjeta-mapa">
  <ion-card-header>
    <div class="titulo-con-informacion">
      <ion-card-title>{{ titulo }}</ion-card-title>
      <ion-button *ngIf="informacion" [id]="idUnico" fill="clear" size="small" class="boton-informacion"
        aria-label="Información">
        <ion-icon name="information-circle-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </div>
    <ion-card-subtitle>
      Visualización geográfica de las visitas filtradas
    </ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <!-- Overlay de carga -->
    <div *ngIf="cargando" class="loading-overlay">
      <ion-spinner name="crescent"></ion-spinner>
      <p>Cargando ubicaciones...</p>
    </div>

    <!-- Contenedor del mapa: no depende de cargando para que Leaflet tenga el DIV en el DOM -->
    <div *ngIf="tieneVisitasConCoordenadas" class="mapa-wrapper" [style.height]="alturaMap">
      <div
        #mapaContainer
        class="mapa-container">
      </div>
    </div>

    <!-- Mensaje cuando no hay visitas con coordenadas -->
    <div *ngIf="!cargando && !tieneVisitasConCoordenadas" class="sin-datos">
      <ion-icon name="location-outline"></ion-icon>
      <p>No hay visitas con ubicación para mostrar</p>
    </div>

    <!-- Leyenda -->
    <div class="leyenda" *ngIf="!cargando && tieneVisitasConCoordenadas && estadosVisita.length > 0">
      <span class="leyenda-item" *ngFor="let estado of estadosVisita">
        <span class="punto" [ngClass]="getClaseEstado(estado.descripcion)"></span>
        {{ estado.descripcion }}
      </span>
    </div>
  </ion-card-content>
</ion-card>

<!-- Popover de información: side="top" y reference="trigger" para alineación correcta en iPad/Chrome -->
<ion-popover *ngIf="informacion" [trigger]="idUnico" [triggerAction]="'click'" reference="trigger" [side]="'top'"
  [alignment]="'center'">
  <ng-template>
    <div class="popover-informacion">
      <p>{{ informacion }}</p>
    </div>
  </ng-template>
</ion-popover>
